import {Outlet, useNavigate} from 'react-router-dom'
import {useAuth} from "@/provider/AuthProvider";
import {FullLoading} from "../components/loading";
import {getAccessToken} from "@/lib/services/tokenService";
import {useEffect} from "react";
import {URLS} from "@/lib/urls";
import {useGetCurrentUser} from "@/api/auth";
import {myAcademy} from "@/lib/services/academyService";
import RenderIf from "@/components/render-if";


export default function PrivateRoute({module}) {

    const {user, setUser, academy, setAcademy} = useAuth()
    const navigate = useNavigate()
    const token = getAccessToken()

    const {
        data: userData,
        error: userError,
        isLoading: userLoading,
        isSuccess: userSuccess,
        isError: userIsError,
    } = useGetCurrentUser({
        enabled: !!token,
    })

    useEffect(() => {
        setUser(null)
        if (!token) {
            navigate(URLS.auth.login)
        }
    }, [])


    useEffect(() => {
        if (!userData?.data?.data) return;
        setUser(userData?.data?.data)
    }, [userData])


    useEffect(() => {
        if (['student', 'teacher', 'admin'].includes(module)) {
            if (!academy) {
                if (myAcademy()) {
                    setAcademy(myAcademy())
                }
            }
        }
    }, [module]);


    if (userLoading) {
        return (<FullLoading/>)
    }

    if (userError) {
        return (
            <div className="absolute w-full h-full flex flex-col justify-center items-center gap-4">
                <RenderIf condition={userIsError}>
                    <span>خطا در دریافت اطلاعات کاربر</span>
                    <button className="z-30" onClick={() => {
                        window.location.href = '/'
                    }}>تلاش مجدد
                    </button>
                </RenderIf>
            </div>
        )
    }


    return (
        <RenderIf condition={userSuccess && user}>
            <Outlet/>
        </RenderIf>
    )
}
